export const TABS = ["Perfil", "Faturamento"];

export const DEFAULT_POOL_IMAGE = "/assets/images/pool.jpg";
